interface NavigationOptions {
    replace?: boolean;
    state?: Record<string, unknown>;
    [key: string]: unknown; // Allow additional properties if needed
}

interface NavigationService {
    navigateTo(path: string, options?: NavigationOptions): void;
}

export class RouteNavigationService implements NavigationService {
    constructor(private navigate: (path: string, options?: NavigationOptions) => void) { }

    navigateTo(path: string, options?: NavigationOptions): void {
        this.navigate(path, options);
    }

    navigateWithMessage(path: string, message: string): void {
        setTimeout(() => {
            this.navigate(path, { state: { message } });
        }, 100);

    }
    navigateWithoutMessage(path: string): void {
        this.navigate('/admin');
        setTimeout(() => {
            this.navigate(path);
        }, 100);
    }
}